const UNCLASSIFIED_EMAILS_STATUSES = {
  PENDING: 'pending',
  PENDING_ASYNC: 'pending_async',
  REPLIED: 'replied',
  FORWARDED: 'forwarded',
  REFER_TO_USER: 'refer_to_user',
  DELETED: 'deleted',
  ATTACHED_TO_CLAIM: 'attached_to_claim',
  MOVED_TO_FNOL_QUEUE: 'moved_to_fnol_queue',
} as const;

export default UNCLASSIFIED_EMAILS_STATUSES;
